import {
  ComponentRef,
  EnvironmentInjector,
  Injectable,
  Type,
} from '@angular/core';
import { PortalHostDirective } from 'src/app/shared/directives/portal-host-directive';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private host: PortalHostDirective | null = null;
  private activeComponentRef: ComponentRef<unknown> | null = null;
  private currentComponent: Type<unknown> | null = null;

  constructor(private environmentInjector: EnvironmentInjector) {}

  registerHost(host: PortalHostDirective): void {
    this.host = host;

    if (this.currentComponent) {
      this.renderCurrentComponent();
    }
  }

  clearHost(host?: PortalHostDirective): void {
    if (!host || this.host === host) {
      this.destroyActiveComponent();
      this.host = null;
    }
  }

  attach(component: Type<unknown>): void {
    this.currentComponent = component;

    if (!this.host) {
      return;
    }

    this.renderCurrentComponent();
  }

  private renderCurrentComponent(): void {
    if (!this.host || !this.currentComponent) {
      return;
    }

    this.destroyActiveComponent();

    const viewContainerRef = this.host.viewContainerRef;
    viewContainerRef.clear();

    this.activeComponentRef = viewContainerRef.createComponent(
      this.currentComponent,
      {
        environmentInjector: this.environmentInjector,
      }
    );
  }

  detach(): void {
    this.destroyActiveComponent();
    this.currentComponent = null;
  }

  // removeComponent(): void {
  //   this.destroyActiveComponent();
  // }

  private destroyActiveComponent(): void {
    if (this.activeComponentRef) {
      this.activeComponentRef.destroy();
      this.activeComponentRef = null;
    }

    this.host?.viewContainerRef.clear();
  }

  // getCurrentComponent(): Type<unknown> | null {
  //   return this.currentComponent;
  // }
}
